import React from "react";
import ProductCategory from "../../productcategory2";
import SEO from "../../seo";

export default function KidsMattressPage() {
  const data = {
    categoryName: "Kids Series",
    description:
      "The Kids mattressis crafted to envelope the spine in a gentle yet firm manner so that every part of body is exercised with due pressure. The mattress is topped with multi layered soft quilted fabric perfectly crafted for kids. Supported and well ventilated Bonnell springs guarantees an optimal contribution to a good and safe night’s rest for the kid. The mattress is Anti-Microbial mattress and ensure proper care for babies.",
    benefits: [
      "Premium mattress range",
      "Non-spring series",
      "Attention to detail",
      "Use of specially treated fabrics with unique advantages",
      "Innovative border designs",
    ],
    products: [
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/baby-cozy.png",
        name: "BABY COZY",
        link: "/kids-mattress/baby-cozy/",
        startingAt: "₹4,099",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/baby-care.png",
        name: "BABY CARE",
        link: "/kids-mattress/baby-care/",
        startingAt: "₹3,199",
      },
    ],
    // brochureLink: "https://eclipsemattress.in/assets/pdfs/Eclipse-Catalog.pdf",
    actionToAccess: false,
    banner: "https://eclipsemattress.in/assets/images/banners/kids-d.jpg",
    bannerSm: "https://eclipsemattress.in/assets/images/banners/kids-m.jpg",
    // pattern,
    // color: "#EFEFEF",
  };
  return (
    <div>
      <SEO
        title="Best Mattress for Kids | Eclipse International"
        description="Eclipse International understand the importantance of your little ones to get a good night's sleep. Check out and buy the best kids mattress to help them remain comfortable throughout the night"
      />
      <ProductCategory category={data} />
    </div>
  );
}
